<style scoped>

  .ui.avatar.image {
    margin-right: 8px;
    height: 24px;
    width: 24px;
  }

</style>

<template>

  <div class="ui fixed menu">

    <div v-if="showLogo" class="item">
      <img class="ui tiny image" src="/assets/images/logo.png">
    </div>

    <div v-if="showAppName" class="item">
      <strong v-if="env == 'test'" class="red text">Portal Corporativo - HML</strong>
      <strong v-else>Portal Corporativo</strong>
    </div>

    <div v-if="isDesktop && !$isCustomerOrProspect()" class="ui simple dropdown item dropdown-menu-item" @click="navTo('/')">
      <div class="icons">
        <i class="pie chart large icon" :class="{ 'blue text': isHomePage }"></i>
      </div>
      <div class="menu">
        <div class="item"><strong :class="{ 'blue text': isHomePage }">Dashboard</strong></div>
      </div>
    </div>

    <div v-if="isDesktop" class="ui simple dropdown item dropdown-menu-item">
      <div class="icons">
        <i class="cubes large icon" :class="{ 'blue text': isProductsPage }"></i>
      </div>
      <div class="menu">
        <div class="item"><strong>Produtos</strong></div>
        <a class="item" @click="navTo('/products/search')">
          <span :class="{ 'blue text': isProductsSearchPage }">
            <i class="search icon"></i> Consultar
          </span>
        </a>
        <a v-if="!$isProspect()" class="item" @click="navTo('/products/reserves')">
          <span :class="{ 'blue text': isProductsReservesPage }">
            <i class="lock icon"></i> {{ $isCustomer() ? 'Minhas reservas' : 'Reservas' }}
          </span>
        </a>
      </div>
    </div>

    <div v-if="isDesktop && !$isCustomerOrProspect()" class="ui simple dropdown item dropdown-menu-item" @click="navTo('/quotations')">
      <div class="icons">
        <i class="file alt large icon" :class="{ 'blue text': isQuotationsPage }"></i>
      </div>
      <div class="menu">
        <div class="item"><strong :class="{ 'blue text': isQuotationsPage }">Orçamentos</strong></div>
      </div>
    </div>

    <div v-if="isDesktop && !$isCustomerOrProspect()" class="ui simple dropdown item dropdown-menu-item" @click="navTo('/customers')">
      <div class="icons">
        <i class="user large icon" :class="{ 'blue text': isCustomersPage }"></i>
      </div>
      <div class="menu">
        <div class="item"><strong :class="{ 'blue text': isCustomersPage }">Clientes</strong></div>
      </div>
    </div>

    <div v-if="isDesktop && $isCustomer()" class="ui simple dropdown item dropdown-menu-item" @click="navToCustomerPage()">
      <div class="icons">
        <i class="search large icon"></i>
      </div>
      <div class="menu">
        <div class="item"><strong>Consultas</strong></div>
      </div>
    </div>

    <div class="right menu">
      <a class="ui simple right dropdown item dropdown-menu-item">
        <div class="icons">
          <i class="large envelope icon" :class="{ 'blue text': isMessagesPage }"></i>
          <span v-if="messages.error" class="ui red circular label animated flash">!</span>
          <span v-if="!messages.error && messages.notDisplayed > 0" class="ui red circular label animated zoomIn">
            {{ messages.notDisplayed }}
          </span>
        </div>
        <div class="menu" style="padding: 15px; min-width: 300px;">
          <div class="ui middle aligned relaxed list">
            <div class="item">
              <strong>{{ messagesLabel }}</strong>
            </div>            
            <div class="item" v-for="message in messages.last">
              <div class="right floated content">
                <div class="black text" style="font-size: 11px;">
                  <i class="checkmark blue small icon"></i>{{ message.when }}
                </div>
              </div>
              <div class="content">
                <span style="font-size: 13px;">{{ message.fromUserName }}</span>
                <div class="description grey text" style="font-size: 12px;">
                  {{ $truncateString(message.subject, 45) }}
                </div>
              </div>
            </div>
            <div class="ui divider"></div>
            <div class="ui basic center aligned segment no-padding no-margin clickable" @click="navTo('/messages')">
              <a>Ver todas as suas mensagens</a>
            </div>
          </div>
        </div>
      </a>

      <a class="ui simple right dropdown item dropdown-menu-item">
        <div class="icons">
          <i class="large bell icon" :class="{ 'blue text': isNotificationsPage }"></i>
          <span v-if="notifications.error" class="ui red circular label animated flash">!</span>
          <span v-if="!notifications.error && notifications.notDisplayed > 0" class="ui red circular label animated zoomIn">
            {{ notifications.notDisplayed }}
          </span>
        </div>
        <div class="menu" style="padding: 15px; min-width: 250px;">
          <div class="ui relaxed list">
            <div class="item">
              <strong>{{ notificationsLabel }}</strong>
            </div>
            <div class="item" v-for="notification in notifications.last">
              <i class="large middle aligned icon" :class="notification.icon + ' ' + notification.iconColor"></i>
              <div class="content">
                <span style="font-size: 13px;">{{ notification.eventName }}</span>
                <div class="description grey text" style="font-size: 11px;">{{ notification.when }}</div>
              </div>
            </div>            
            <div class="ui divider"></div>
            <div class="ui basic center aligned segment no-padding no-margin clickable" @click="navTo('/notifications')">
              <a>Ver todas as suas notificações</a>
            </div>
          </div>
        </div>
      </a>

      <a v-if="isMobile" class="item" @click="showSidebar()">
        <i class="bars large icon menu-icon"></i>
      </a>

      <div v-if="isDesktop" class="ui simple dropdown item dropdown-menu-item">
        <img class="ui avatar image" src="/assets/images/user.png">
        <div class="text" :class="{ blue: isProfilePage, black: !isProfilePage }">{{ $store.state.user.name }}<i class="dropdown icon"></i></div>
        <div class="menu">
          <a class="item" @click="navTo('/profile')">
            <span :class="{ 'blue text': isProfilePage }">
              <i class="edit left icon"></i> Perfil
            </span>
          </a>
          <a class="item" @click="navTo('/use-terms')">
            <span :class="{ 'blue text': isUseTermsPage }">
              <i class="info circle left icon"></i> Termos de Uso
            </span>
          </a>
          <div class="divider"></div>
          <a class="item" @click="onLogout()">
            <i class="sign out icon"></i> Sair
          </a>
        </div>
      </div>
    </div>

  </div>

</template>

<script>

  import config from "../../config.json"
  import AppBrowser from "@/utils/browser"
  import isPageMixin from "@/mixins/ispage"  
  import { MessageService, NotificationService } from "@/services"

  export default {

    data() {
      return {
        env: config.env,
        isMobile: AppBrowser.isMobile(),
        isDesktop: !AppBrowser.isMobile(),
        showLogo: true,
        showAppName: true,
        messages: { error: false, last: [], notDisplayed: 0 },
        notifications: { error: false, last: [], notDisplayed: 0 },
      }
    },

    mixins: [isPageMixin],

    watch: {

      "$store.state.updateMessages" () {

        if (this.$store.state.updateMessages) {
          this.updateMessages()    
          this.$store.commit("setUpdateMessages", false)
        }  
      },

      "$store.state.updateNotifications" () {

        if (this.$store.state.updateNotifications) {
          this.updateNotifications()    
          this.$store.commit("setUpdateNotifications", false)
        }  
      },
    },

    computed: {

      messagesLabel() {

        if (this.messages.error)
          return "Falha ao obter mensagens"

        let label = ""
        const notDisplayed =  this.messages.notDisplayed

        if (notDisplayed == 0) {
          label = "Nenhuma nova mensagem"
        } else if (notDisplayed == 1) {
          label = "1 nova mensagem"
        } else {
          label = `${notDisplayed} novas mensagens`
        }

        return label
      },

      notificationsLabel() {

        if (this.messages.error)
          return "Falha ao obter notificações"

        let label = ""
        const notDisplayed =  this.notifications.notDisplayed

        if (notDisplayed == 0) {
          label = "Nenhuma nova notificação"
        } else if (notDisplayed == 1) {
          label = "1 nova notificação"
        } else {
          label = `${notDisplayed} novas notificações`
        }

        return label
      },
    },

    created() {

      document.title = "Cobrecom | Portal Corporativo"

      this.updateMessages()
      this.updateNotifications()

      setInterval(this.updateMessages, (config.client.updateInterval.messages * 60000))
      setInterval(this.updateNotifications, (config.client.updateInterval.notifications * 60000))
    },

    mounted() {

      const width = $(window).width()

      if (width < 500)
        this.showLogo = false      

      if (width < 374)
        this.showAppName = false    

      if (width < 720) {
        this.isMobile = true
        this.isDesktop = false
      }  
        
      $(".menu .item").tab()        
    },

    methods: {

      navTo(route) {        
        this.$router.push(route)
      },

      navToCustomerPage() {
         
        const customer = this.$store.state.user.customer
        let route = `/customers/show/${customer.code}/${customer.unit}`

        this.$router.push(route)
      },

      showSidebar() {
        $("#sidebar").sidebar("show")
      },

      onLogout() {
        this.$emit("onLogout")
      },

      async updateMessages() {

        try {

          const response = await MessageService.find({ maxRegs: 5 })
          
          this.messages = {
            error: false,
            last: response.messages,
            notDisplayed: response.notDisplayedCount,
          }
          
        } catch (error) {

          this.messages = {
            error: true,
            last: [],
            notDisplayed: 0,
          }
          
          this.$errorHandler(error, { silent: true })
        }
      },

      async updateNotifications() {

        try {

          const response = await NotificationService.find({ maxRegs: 5 })
          
          this.notifications = {
            error: false,
            last: response.notifications,
            notDisplayed: response.notDisplayedCount,
          }
          
        } catch (error) {

          this.notifications = {
            error: true,
            last: [],
            notDisplayed: 0,
          }
          
          this.$errorHandler(error, { silent: true })
        }
      },
    },

  }


</script>
